import LinkToDocusaurus from '../LinkToDocusaurus'
import { agentTools } from '../../docs-routes'

const LinkToAgentToolsDoc = () =>
  <LinkToDocusaurus path={agentTools}>
    Learn more about Agent Tools
  </LinkToDocusaurus>

export default LinkToAgentToolsDoc
